(() => {
  const storageKeyPrefix = 'five-zero-age-verification-accepted';

  const storageKey = (scope) => `${storageKeyPrefix}:${scope}`;

  const hasAccepted = (scope) => {
    try {
      return window.localStorage.getItem(storageKey(scope)) === 'true';
    } catch {
      return false;
    }
  };

  const saveAcceptance = (scope) => {
    try {
      window.localStorage.setItem(storageKey(scope), 'true');
    } catch {
      return;
    }
  };

  const initDialog = (dialog) => {
    if (dialog.dataset.initialized === 'true') return;

    dialog.dataset.initialized = 'true';
    const confirmButton = dialog.querySelector('[data-age-verification-confirm]');
    const isDesignMode = Boolean(window.Shopify?.designMode);
    const storageScope = dialog.dataset.storageScope;
    const isRestrictedPage = dialog.dataset.pageRequiresVerification === 'true';
    const accepted = storageScope ? hasAccepted(storageScope) : false;
    const originalConfirmLabel = confirmButton?.textContent;

    if (!storageScope || !isRestrictedPage) {
      dialog.remove();
      return;
    }

    dialog.addEventListener('cancel', (event) => {
      event.preventDefault();
    });

    dialog.addEventListener('close', () => {
      document.documentElement.classList.remove('age-verification-is-open');
    });

    confirmButton?.addEventListener('click', async () => {
      if (isDesignMode) {
        dialog.close();
        return;
      }

      confirmButton.disabled = true;
      confirmButton.setAttribute('aria-busy', 'true');
      confirmButton.textContent = originalConfirmLabel;

      try {
        saveAcceptance(storageScope);
        dialog.close();
        dialog.remove();
      } catch (error) {
        console.error(error);
        confirmButton.textContent = dialog.dataset.errorLabel;
        confirmButton.disabled = false;
        confirmButton.removeAttribute('aria-busy');
      }
    });

    const showDialog = () => {
      window.setTimeout(
        () => {
          if (!dialog.open && dialog.isConnected) {
            document.documentElement.classList.add('age-verification-is-open');
            dialog.showModal();
            dialog.focus({ preventScroll: true });
          }
        },
        isDesignMode ? 0 : 1000
      );
    };

    if (isDesignMode) {
      showDialog();
      return;
    }

    if (accepted) {
      dialog.remove();
      return;
    }

    showDialog();
  };

  const init = (scope = document) => {
    scope.querySelectorAll('[data-age-verification]').forEach(initDialog);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
